import GetWidgetEventDetailRequestModelBase from '../_generated/modelBases/get-widget-event-detail-request-model-base';

export default class GetWidgetEventDetailRequestModel extends GetWidgetEventDetailRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
